interface Scripts {
    name: string;
    src: string;
}  
export const ScriptStore: Scripts[] = [
    // {name: 'filepicker', src: 'https://api.filestackapi.com/filestack.js'},
    // {name: 'rangeSlider', src: '../../../assets/js/ion.rangeSlider.min.js'},
    { name: "vendor/modernizr-3.5.0.min", src: "/assets/js/vendor/modernizr-3.5.0.min.js" },
    { name: "vendor/jquery-1.12.4.min", src: "/assets/js/vendor/jquery-1.12.4.min.js" },
    { name: "popper.min", src: "/assets/js/popper.min.js" },
    { name: "bootstrap.min", src: "/assets/js/bootstrap.min.js" },
    { name: "jquery.slicknav.min", src: "/assets/js/jquery.slicknav.min.js" },
    { name: "owl.carousel.min", src: "/assets/js/owl.carousel.min.js" },
    { name: "slick.min", src: "/assets/js/slick.min.js" },
    { name: "gijgo.min", src: "/assets/js/gijgo.min.js" },
    { name: "wow.min", src: "/assets/js/wow.min.js" },
    { name: "animated.headline", src: "/assets/js/animated.headline.js" },
    { name: "jquery.magnific-popup", src: "/assets/js/jquery.magnific-popup.js" },
    { name: "jquery.scrollUp.min", src: "/assets/js/jquery.scrollUp.min.js" },
    { name: "jquery.nice-select.min", src: "/assets/js/jquery.nice-select.min.js" },
    { name: "jquery.sticky", src: "/assets/js/jquery.sticky.js" },
    { name: "waypoints", src: "http://cdnjs.cloudflare.com/ajax/libs/waypoints/2.0.3/waypoints.min.js" },
    { name: "jquery.counterup.min", src: "/assets/js/jquery.counterup.min.js" },
    { name: "contact", src: "/assets/js/contact.js" },
    { name: "jquery.form", src: "/assets/js/jquery.form.js" },
    { name: "jquery.validate.min", src: "/assets/js/jquery.validate.min.js" },
    { name: "mail-script", src: "/assets/js/mail-script.js" },
    { name: "jquery.ajaxchimp.min", src: "/assets/js/jquery.ajaxchimp.min.js" },
    { name: "plugins", src: "/assets/js/plugins.js" },
    { name: "start", src: "/assets/js/start.js" },
];


